<div mat-dialog-title>{{data.title}}</div>
<div mat-dialog-content>

    <div class="dialog-description pb-4">{{ data.message }}</div>
</div>
<div mat-dialog-actions align="end" class="text-right">
    <button class="btn default-button btn-highlight-1 rounded" mat-button [mat-dialog-close]="true" tabindex="-1"> Confirm </button>
</div>
